import { render, staticRenderFns } from "./TravelAddressVue.vue?vue&type=template&id=52e89d37"
import script from "./TravelAddressVue.vue?vue&type=script&lang=js"
export * from "./TravelAddressVue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports